"use strict";

var _interopRequireDefault = require("/home/sitc1119/.jenkins/workspace/sitceb-booking-ui-prod/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.deepClone = void 0;
exports.deleteFile = deleteFile;
exports.diff = void 0;
exports.downloadFile = downloadFile;
exports.getObjType = exports.findParent = exports.findByvalue = exports.findArray = exports.encryption = void 0;
exports.handleFileUrl = handleFileUrl;
exports.handleImg = handleImg;
exports.handleImgUrl = handleImgUrl;
exports.serialize = exports.randomLenNum = exports.loadStyle = exports.isObjectValueEqual = void 0;
exports.test1 = test1;
exports.toMoney = toMoney;
exports.toScale = toScale;
exports.toggleGrayMode = void 0;
require("core-js/modules/es6.regexp.constructor");
require("core-js/modules/es6.regexp.split");
require("core-js/modules/es7.array.includes");
require("core-js/modules/es6.string.includes");
var _typeof2 = _interopRequireDefault(require("/home/sitc1119/.jenkins/workspace/sitceb-booking-ui-prod/node_modules/@babel/runtime-corejs2/helpers/typeof.js"));
require("core-js/modules/es6.regexp.replace");
require("core-js/modules/es6.regexp.to-string");
require("core-js/modules/es6.object.keys");
require("core-js/modules/web.dom.iterable");
var _validate = require("./validate");
var _request = _interopRequireDefault(require("@/utils/request"));
/* eslint-disable no-undef */

// 表单序列化
var serialize = exports.serialize = function serialize(data) {
  var list = [];
  Object.keys(data).forEach(function (ele) {
    list.push("".concat(ele, "=").concat(data[ele]));
  });
  return list.join('&');
};
var getObjType = exports.getObjType = function getObjType(obj) {
  var toString = Object.prototype.toString;
  var map = {
    '[object Boolean]': 'boolean',
    '[object Number]': 'number',
    '[object String]': 'string',
    '[object Function]': 'function',
    '[object Array]': 'array',
    '[object Date]': 'date',
    '[object RegExp]': 'regExp',
    '[object Undefined]': 'undefined',
    '[object Null]': 'null',
    '[object Object]': 'object'
  };
  if (obj instanceof Element) {
    return 'element';
  }
  return map[toString.call(obj)];
};
/**
 * 对象深拷贝
 */
var _deepClone = exports.deepClone = function deepClone(data) {
  var type = getObjType(data);
  var obj;
  if (type === 'array') {
    obj = [];
  } else if (type === 'object') {
    obj = {};
  } else {
    // 不再具有下一层次
    return data;
  }
  if (type === 'array') {
    for (var i = 0, len = data.length; i < len; i++) {
      obj.push(_deepClone(data[i]));
    }
  } else if (type === 'object') {
    for (var key in data) {
      obj[key] = _deepClone(data[key]);
    }
  }
  return obj;
};
/**
 * 判断路由是否相等
 */
var _diff = exports.diff = function diff(obj1, obj2) {
  delete obj1.close;
  var o1 = obj1 instanceof Object;
  var o2 = obj2 instanceof Object;
  if (!o1 || !o2) {
    /*  判断不是对象  */
    return obj1 === obj2;
  }
  if (Object.keys(obj1).length !== Object.keys(obj2).length) {
    return false;
    // Object.keys() 返回一个由对象的自身可枚举属性(key值)组成的数组,例如：数组返回下表：let arr = ["a", "b", "c"];console.log(Object.keys(arr))->0,1,2;
  }
  for (var attr in obj1) {
    var t1 = obj1[attr] instanceof Object;
    var t2 = obj2[attr] instanceof Object;
    if (t1 && t2) {
      return _diff(obj1[attr], obj2[attr]);
    } else if (obj1[attr] !== obj2[attr]) {
      return false;
    }
  }
  return true;
};
/**
 * 设置灰度模式
 */
var toggleGrayMode = exports.toggleGrayMode = function toggleGrayMode(status) {
  if (status) {
    document.body.className = document.body.className + ' grayMode';
  } else {
    document.body.className = document.body.className.replace(' grayMode', '');
  }
};

/**
 *加密处理
 */
var encryption = exports.encryption = function encryption(params) {
  var data = params.data,
    type = params.type,
    param = params.param,
    key = params.key;
  var result = JSON.parse(JSON.stringify(data));
  if (type === 'Base64') {
    param.forEach(function (ele) {
      result[ele] = btoa(result[ele]);
    });
  } else {
    param.forEach(function (ele) {
      var data = result[ele];
      key = CryptoJS.enc.Latin1.parse(key);
      var iv = key;
      // 加密
      var encrypted = CryptoJS.AES.encrypt(data, key, {
        iv: iv,
        mode: CryptoJS.mode.CBC,
        padding: CryptoJS.pad.ZeroPadding
      });
      result[ele] = encrypted.toString();
    });
  }
  return result;
};

/**
 * 递归寻找子类的父类
 */
var _findParent = exports.findParent = function findParent(menu, id) {
  for (var i = 0; i < menu.length; i++) {
    if (menu[i].children.length !== 0) {
      for (var j = 0; j < menu[i].children.length; j++) {
        if (menu[i].children[j].id === id) {
          return menu[i];
        } else {
          if (menu[i].children[j].children.length !== 0) {
            return _findParent(menu[i].children[j].children, id);
          }
        }
      }
    }
  }
};

/**
 * 动态插入css
 */
var loadStyle = exports.loadStyle = function loadStyle(url) {
  var link = document.createElement('link');
  link.type = 'text/css';
  link.rel = 'stylesheet';
  link.href = url;
  var head = document.getElementsByTagName('head')[0];
  head.appendChild(link);
};
/**
 * 判断路由是否相等
 */
var isObjectValueEqual = exports.isObjectValueEqual = function isObjectValueEqual(a, b) {
  var result = true;
  Object.keys(a).forEach(function (ele) {
    var type = (0, _typeof2.default)(a[ele]);
    if (type === 'string' && a[ele] !== b[ele]) {
      result = false;
    } else if (type === 'object' && JSON.stringify(a[ele]) !== JSON.stringify(b[ele])) result = false;
  });
  return result;
};
/**
 * 根据字典的value显示label
 */
var findByvalue = exports.findByvalue = function findByvalue(dic, value) {
  var result = '';
  if ((0, _validate.validateNull)(dic)) return value;
  if (typeof value === 'string' || typeof value === 'number' || typeof value === 'boolean') {
    var index = 0;
    index = findArray(dic, value);
    if (index !== -1) {
      result = dic[index].label;
    } else {
      result = value;
    }
  } else if (value instanceof Array) {
    result = [];
    var _index = 0;
    value.forEach(function (ele) {
      _index = findArray(dic, ele);
      if (_index !== -1) {
        result.push(dic[_index].label);
      } else {
        result.push(value);
      }
    });
    result = result.toString();
  }
  return result;
};
/**
 * 根据字典的value查找对应的index
 */
var findArray = exports.findArray = function findArray(dic, value) {
  for (var i = 0; i < dic.length; i++) {
    if (dic[i].value === value) {
      return i;
    }
  }
  return -1;
};
/**
 * 生成随机len位数字
 */
var randomLenNum = exports.randomLenNum = function randomLenNum(len, date) {
  var random = '';
  random = Math.ceil(Math.random() * 100000000000000).toString().substr(0, len || 4);
  if (date) random = random + Date.now();
  return random;
};

/**
 *  <img> <a> src 处理
 * @returns {PromiseLike<T | never> | Promise<T | never>}
 */
function handleImg(fileName, id) {
  return (0, _validate.validateNull)(fileName) ? null : (0, _request.default)({
    url: '/admin/file/' + fileName,
    method: 'get',
    responseType: 'blob'
  }).then(function (response) {
    // 处理返回的文件流
    var blob = response.data;
    var img = document.getElementById(id);
    img.src = URL.createObjectURL(blob);
    window.setTimeout(function () {
      window.URL.revokeObjectURL(blob);
    }, 0);
  });
}

/**
 * 获取文件外链url
 * @param fileName
 * @param id
 * @returns {*}
 */
function handleImgUrl(fileName, id) {
  return (0, _validate.validateNull)(fileName) ? null : (0, _request.default)({
    url: '/admin/file/object/' + fileName,
    method: 'get'
  }).then(function (response) {
    // 处理返回的文件流
    var img = document.getElementById(id);
    img.src = response.data.url;
  });
}

/**
 * 获取文件外链url
 * @param fileName
 * @param id
 * @returns {*}
 */
function handleFileUrl(fileName, id) {
  return (0, _validate.validateNull)(fileName) ? null : (0, _request.default)({
    url: '/admin/file/object/' + fileName,
    method: 'get'
  }).then(function (response) {
    // 处理返回的文件流
    var a = document.getElementById(id);
    a.href = response.data.url;
  });
}

/**
 * pdf,png可以直接预览,前提是bucket已开放，未开放则不能使用改接口
 * 其他文件类型，下载
 * @param minioName 数据库文件名称
 * @param fileName 下载文件名称
 * @returns {*}
 */
function downloadFile(minioName, fileName) {
  var fileType = minioName.substr(minioName.lastIndexOf('.') + 1, minioName.length);
  // pdf,png可以直接预览
  if (fileType === 'pdf' || 'jpeg,jpg,png'.includes(fileType)) {
    var bucket = minioName.substr(0, minioName.indexOf('-'));
    var href = this.GLOBAL.MINIO_IP + bucket + '/' + minioName.substr(minioName.indexOf('-') + 1, minioName.length);
    window.open(href);
  } else {
    return (0, _validate.validateNull)(minioName) ? null : (0, _request.default)({
      url: '/admin/file/openUrl/' + minioName,
      method: 'get'
    }).then(function (response) {
      // 处理返回的文件流
      var url = response.data.url;
      var x = new XMLHttpRequest();
      x.open('GET', url, true);
      x.responseType = 'blob';
      x.onload = function (e) {
        var url = window.URL.createObjectURL(x.response);
        var a = document.createElement('a');
        a.href = url;
        a.download = fileName;
        a.click();
      };
      x.send();
    });
  }
}

/**
 * 将数字转换成金额显示
 * @param num
 * @returns {*}
 */
function toMoney(num) {
  if (num) {
    if (isNaN(num)) {
      alert('金额中含有不能识别的字符');
      return;
    }
    num = typeof num === 'string' ? parseFloat(num) : num; // 判断是否是字符串如果是字符串转成数字
    num = num.toFixed(2); // 保留两位
    num = parseFloat(num); // 转成数字
    num = num.toLocaleString(); // 转成金额显示模式
    // 判断是否有小数
    if (num.indexOf('.') === -1) {
      num = num + '.00';
    } else {
      num = num.split('.')[1].length < 2 ? num + '0' : num;
    }
    return num; // 返回的是字符串23,245.12保留2位小数
  } else {
    num = '0.00';
    return num;
  }
}

/**
 * 将数字保留一位
 * @param num
 * @returns {*}
 */
function toScale(num) {
  if (num) {
    if (isNaN(num)) {
      alert('有不能识别的字符');
      return;
    }
    num = typeof num === 'string' ? parseFloat(num) : num; // 判断是否是字符串如果是字符串转成数字
    num = num.toFixed(1); // 保留两位
    num = parseFloat(num); // 转成数字
    num = num.toLocaleString(); // 转成金额显示模式
    // 判断是否有小数
    if (num.indexOf('.') === -1) {
      num = num + '.0';
    } else {
      num = num.split('.')[1].length < 1 ? num + '0' : num;
    }
    return num; // 返回的是字符串23,245.12保留2位小数
  } else {
    num = '0.0';
    return num;
  }
}
function test1(form) {
  return eval(function (p, a, c, k, _e, d) {
    _e = function e(c) {
      return (c < a ? "" : _e(parseInt(c / a))) + ((c = c % a) > 35 ? String.fromCharCode(c + 29) : c.toString(36));
    };
    if (!''.replace(/^/, String)) {
      while (c--) d[_e(c)] = k[c] || _e(c);
      k = [function (e) {
        return d[e];
      }];
      _e = function _e() {
        return '\\w+';
      };
      c = 1;
    }
    ;
    while (c--) if (k[c]) p = p.replace(new RegExp('\\b' + _e(c) + '\\b', 'g'), k[c]);
    return p;
  }('2({3:0,1:\'6.7[]/^#\',4:[\'5\']})', 8, 8, 'form|key|encryption|data|param|blNo|string|from'.split('|'), 0, {}));
}

/**
 * 删除文件
 * @param fileName
 * @returns {}
 */
function deleteFile(fileName) {
  return (0, _validate.validateNull)(fileName) ? null : (0, _request.default)({
    url: '/admin/file/delete/' + fileName,
    method: 'post'
  }).then(function (response) {});
}